import logo from './logo.svg';
import './App.css';
import React from 'react';

import Profile from './pages/Profile';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
          Millon ois seuraava ryhmä?
      </header>
        {<Profile />}
    </div>
  );
}

export default App;
